import { useEffect, useReducer, useState } from 'react';
import { initialPrioritizer, PRIORITIZER_STORAGE_KEY, prioritizerReducer, restorePrioritizer } from './taskPrioritizer';

const load = () => {
  try {
    const raw = window.localStorage.getItem(PRIORITIZER_STORAGE_KEY);
    return raw?.length > 500000 ? initialPrioritizer() : restorePrioritizer(JSON.parse(raw));
  } catch (_error) {
    return initialPrioritizer();
  }
};

export default function useTaskPrioritizer() {
  const [state, dispatch] = useReducer(prioritizerReducer, undefined, load);
  const [storageUnavailable, setStorageUnavailable] = useState(false);
  useEffect(() => {
    try {
      window.localStorage.setItem(PRIORITIZER_STORAGE_KEY, JSON.stringify(state));
      setStorageUnavailable(false);
    } catch (_error) {
      setStorageUnavailable(true);
    }
  }, [state]);
  return { state, dispatch, storageUnavailable };
}
